import { t } from 'i18next';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { setGlobalFilter } from '../../../../store/slice/global-filters';
import { GeoClass } from '../../../../interface/response/GeoFiltersResponse';

interface OptionsListProps {
  column: string;
  filters: any;
  handleChange?: (col: string, option: GeoClass) => void;
  filteredOptions: GeoClass[];
  checkbox: boolean;
}

const OptionsList: React.FC<OptionsListProps> = ({ column, filters, handleChange, filteredOptions, checkbox }) => {
  const dispatch = useAppDispatch();
  let content;

  if (checkbox) {
    content = filteredOptions?.map((opt: GeoClass) => {
      const isChecked = (filters[column] || []).some((f: GeoClass) => f.ID === opt.ID);

      return (
        <div key={opt.ID} className="option_checkbox">
          <input type="checkbox" checked={isChecked} readOnly name="checkbox" />
          <div className="option" onClick={() => handleChange && handleChange(column, opt)}>
            <span> {opt.Name}</span>
          </div>
        </div>
      );
    });
  } else {
    content = filteredOptions?.map((opt: GeoClass) => (
      <div key={opt.ID} className="option_radio">
        <label className="option">
          <input
            type="radio"
            value={opt.ID}
            checked={filters[column]?.id === opt.ID}
            onChange={() =>
              dispatch(
                setGlobalFilter({
                  key: column as any,
                  value: {
                    id: opt.ID,
                    name: opt.Name,
                  },
                }),
              )
            }
            name={'radio' + column}
          />
          {t(opt.Name)}
        </label>
      </div>
    ));
  }

  return <>{content}</>;
};

export default OptionsList;
